<div class="width100 text-align-center margin-top40">
  {{'Update in progress...' | translate}}
</div>

